module.exports = __webpack_public_path__ + "static/media/New_Series_3_Ep5_Future_farms_Tablet.b5bd5d0b.jpg";